var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useState, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import LinearGradient from '@hfe/max-linear-gradient';
import TopView from '@max/leez-top-view';
import Image from '@max/leez-image';
import ModalBaseContainer from '@max/leez-modal-base-container';
import { DrawStatus, TeamRankingStatus } from '@/types/teamRanking';
import { getFullScreenSize } from '@/utils/layout';
import SlotMachine from './slot-machine';
import './index.scss';
const isMRN = false;
import { BID_MAP } from '@/const';
import Sensor from '@max/mbc-sensor';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
const DEFAULT_REEL_IMAGE = 'https://p0.meituan.net/ingee/ad67760fcac6309a7eeae4b9870cf2d762827.png';
const DrawModule = ({ drawInfo, onDraw, onDrawSuccess, onShare, reelImage, rewardUuids = [], lxReport, teamRankingStatus }) => {
    var _a, _b, _c, _d, _e, _f;
    const reelImageUrl = reelImage || DEFAULT_REEL_IMAGE;
    const reelImages = [reelImageUrl, reelImageUrl, reelImageUrl];
    const prizeCount = rewardUuids.length || 13;
    /** 根据奖励 uuid 在配置数组中的 index 确定滚动位置，未匹配时返回 -1 */
    const getRewardIndexByUuid = (uuid) => {
        const idx = rewardUuids.indexOf(uuid);
        return idx >= 0 ? idx : -1;
    };
    const initIndexs = [4 % prizeCount, 8 % prizeCount, 12 % prizeCount];
    // const initIndexs = [4,8,11]
    const [winningIndexes, setWinningIndexes] = useState(initIndexs);
    const [slotMachineSpinController, setSlotMachineSpinController] = useState(0);
    const spinRunning = useRef(false);
    const drawResultRef = useRef(null);
    const slotMachineRef = useRef(null);
    const [prizeModalVisible, setPrizeModalVisible] = useState(false);
    const [noPrizeModalVisible, setNoPrizeModalVisible] = useState(false);
    const [selectedPrize, setSelectedPrize] = useState(null);
    const systemType = getSystemType();
    const isIos = systemType === SystemType.ios;
    const { fullScreenHeight } = getFullScreenSize();
    const canDrawCnt = (_b = (_a = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _a === void 0 ? void 0 : _a.canDrawCnt) !== null && _b !== void 0 ? _b : 0;
    const isPublicityStage = teamRankingStatus === TeamRankingStatus.PUBLICITY || teamRankingStatus === TeamRankingStatus.WON_REWARD || teamRankingStatus === TeamRankingStatus.CALCULATING;
    const drawOver = !isPublicityStage && ((_c = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _c === void 0 ? void 0 : _c.drawChanceStatus) !== DrawStatus.USED_UP;
    const getDrawBtnText = () => {
        var _a, _b;
        if (isPublicityStage || ((_a = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _a === void 0 ? void 0 : _a.drawChanceStatus) === DrawStatus.USED_UP) {
            return '已抽奖';
        }
        if (((_b = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _b === void 0 ? void 0 : _b.drawChanceStatus) === DrawStatus.HIDE_INVITE) {
            return '点击抽奖';
        }
        return '邀请好友';
    };
    const handleDraw = () => __awaiter(void 0, void 0, void 0, function* () {
        var _g, _h, _j, _k;
        if (spinRunning.current) {
            return;
        }
        // 重置老虎机状态
        (_g = slotMachineRef.current) === null || _g === void 0 ? void 0 : _g.resetSpin();
        spinRunning.current = true;
        try {
            const res = yield onDraw();
            if ((_j = (_h = res === null || res === void 0 ? void 0 : res.extra) === null || _h === void 0 ? void 0 : _h.rewardVOS) === null || _j === void 0 ? void 0 : _j.length) {
                const reward = res.extra.rewardVOS[0];
                drawResultRef.current = reward;
                const rewardIndex = getRewardIndexByUuid((_k = reward.uuid) !== null && _k !== void 0 ? _k : '');
                setWinningIndexes([rewardIndex, rewardIndex, rewardIndex]); // 中奖
                if (rewardIndex === -1) {
                    drawResultRef.current = null;
                    setWinningIndexes(initIndexs); // 未中奖停回初始化的状态
                }
            }
            else {
                drawResultRef.current = null;
                setWinningIndexes(initIndexs); // 未中奖停回初始化的状态
            }
            // 等待下一个 tick 再启动动画
            setTimeout(() => {
                setSlotMachineSpinController(prev => prev + 1);
            }, 0);
        }
        catch (_l) {
            spinRunning.current = false;
        }
    });
    const onSlotMachineEnd = () => {
        spinRunning.current = false;
        const prizeResult = drawResultRef.current;
        if (prizeResult) {
            setSelectedPrize(prizeResult);
            setPrizeModalVisible(true);
        }
        else {
            setNoPrizeModalVisible(true);
        }
        onDrawSuccess === null || onDrawSuccess === void 0 ? void 0 : onDrawSuccess();
        drawResultRef.current = null;
    };
    const renderPrizeModal = () => {
        var _a, _b, _c;
        if (!prizeModalVisible || !selectedPrize)
            return null;
        const prizeInfo = {
            prizeAmount: 0,
            content: ""
        };
        // 返现
        if ((selectedPrize === null || selectedPrize === void 0 ? void 0 : selectedPrize.type) === 1 && ((_a = selectedPrize.cashExtra) === null || _a === void 0 ? void 0 : _a.obtainAmount)) {
            prizeInfo.prizeAmount = ((_b = selectedPrize.cashExtra) === null || _b === void 0 ? void 0 : _b.obtainAmount) / 100;
            prizeInfo.content = "已返现至美团余额";
        }
        else if ((selectedPrize === null || selectedPrize === void 0 ? void 0 : selectedPrize.type) === 3 && ((_c = selectedPrize.couponExtra) === null || _c === void 0 ? void 0 : _c.reduceAmount)) {
            prizeInfo.prizeAmount = 70;
            prizeInfo.content = `满 ${700} 可用`;
        }
        else {
            return null;
        }
        return <TopView>
        <ModalBaseContainer visible={prizeModalVisible} contentStyle={{
            width: '750rpx',
            height: fullScreenHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        }}>
          <View className="draw-prize-modal-content-wrap">
            <View>
              <Image source={{
            uri: 'https://p0.meituan.net/ingee/6d2de462bee88f647fe6bae6823288ea25006.png'
        }} style={{
            width: '326rpx',
            height: '86rpx',
            marginBottom: '27rpx'
        }} borderRadius={0}/>
            </View>
            <Image source={{
            uri: (selectedPrize === null || selectedPrize === void 0 ? void 0 : selectedPrize.type) === 1 ? 'https://p0.meituan.net/ingee/52fadb025dfd1fe090736ff6d7ef2a118440.png' : 'https://p0.meituan.net/ingee/5a675d93e6793c082424021ddcfb6a519586.png'
        }} style={{
            width: '566rpx',
            height: '512rpx'
        }} resizeMode="cover" borderRadius={0}>
              <View style={{
            display: "flex",
            flexDirection: 'column',
            justifyContent: "flex-start",
            alignItems: "center",
            marginTop: isMRN ? isIos ? "84rpx" : "126rpx" : "96rpx"
        }}>
                <Text className={"draw-prize"}>
                  <Text style={{
            fontSize: "36rpx",
            fontWeight: "bold"
        }}>¥</Text>
                  <Text style={{
            fontSize: "136rpx",
            fontFamily: 'MTNewDigitalDisplay-Bold'
        }}>{prizeInfo.prizeAmount}</Text>
                </Text>
                <Text className={"draw-no-prize-modal-content"}>{prizeInfo.content}</Text>
                <Image onPress={() => {
            setNoPrizeModalVisible(false);
            setSelectedPrize(null);
        }} source={{
            uri: 'https://p0.meituan.net/ingee/556138c28193f282bc560ccdd39c88e816626.png'
        }} style={{
            width: '492rpx',
            height: '70rpx',
            marginTop: '60rpx'
        }}/>
              </View>
            </Image>
            <Image onPress={() => {
            setPrizeModalVisible(false);
            setSelectedPrize(null);
        }} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx'
        }} className="draw-prize-modal-close-btn"/>
          </View>
        </ModalBaseContainer>
      </TopView>;
    };
    const renderNoPrizeModal = () => {
        if (!noPrizeModalVisible)
            return null;
        return <TopView>
        <ModalBaseContainer visible={noPrizeModalVisible} contentStyle={{
            width: '750rpx',
            height: fullScreenHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        }}>
          <View className="draw-no-prize-modal-content-wrap">
            <Image source={{
            uri: 'https://p0.meituan.net/ingee/3d36a05d817eb8ed10fd7990da3796e424061.png'
        }} style={{
            width: '326rpx',
            height: '65rpx',
            marginBottom: '54rpx'
        }} resizeMode="cover" borderRadius={0}/>
            <Image source={{
            uri: 'https://p0.meituan.net/ingee/b3c33bf58942e737b397e1c269a5ed794349.png'
        }} style={{
            width: '566rpx',
            height: '415rpx'
        }} resizeMode="cover" borderRadius={0}>
              <View style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: 'column',
            justifyContent: "flex-start",
            alignItems: "center"
        }}>
                <Text className={"draw-no-prize-modal-title"}>未中奖</Text>
                <Text className={"draw-no-prize-modal-content"}>明日再来抽返现吧～</Text>
                <Image onPress={() => setNoPrizeModalVisible(false)} source={{
            uri: 'https://p0.meituan.net/ingee/556138c28193f282bc560ccdd39c88e816626.png'
        }} style={{
            width: '492rpx',
            height: '70rpx',
            marginTop: '60rpx'
        }}/>
              </View>
            </Image>
            <Image onPress={() => setNoPrizeModalVisible(false)} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx'
        }} className="draw-no-prize-modal-close-btn"/>
          </View>
        </ModalBaseContainer>
      </TopView>;
    };
    const rewardVOS = (_e = (_d = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _d === void 0 ? void 0 : _d.rewardVOS) !== null && _e !== void 0 ? _e : [];
    return <Sensor once onAppear={() => lxReport(BID_MAP.DRAW_MODULE_MV)}>
      <View className="draw-module-container">
      
      <View className="draw-module-title-row">
        <Text className="draw-module-title">{'邀请好友获得抽奖机会'}</Text>
        
      </View>

      

      <View style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }}>
        
        <SlotMachine ref={slotMachineRef} reelImage={reelImages} prizeCount={prizeCount} initialIndexes={winningIndexes} winningIndexes={winningIndexes} onStart={() => { }} onEnd={onSlotMachineEnd} slotMachineSpinController={slotMachineSpinController}/>

        
        <View className="draw-module-bottom-row">

          
          <View className="draw-module-btn-area">
            <Button onPress={() => {
        var _a, _b;
        lxReport(BID_MAP.DRAW_MODULE_MC);
        if (isPublicityStage) {
            return;
        }
        if (((_a = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _a === void 0 ? void 0 : _a.drawChanceStatus) === DrawStatus.HIDE_INVITE) {
            handleDraw();
        }
        else if (((_b = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _b === void 0 ? void 0 : _b.drawChanceStatus) === DrawStatus.SHOW_INVITE) {
            onShare === null || onShare === void 0 ? void 0 : onShare();
        }
    }} className="draw-module-btn-wrapper">
              <LinearGradient colors={drawOver ? ['#FFE74D', '#FFDD00'] : ['#FFE74D', '#FFDD00']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className={`draw-module-btn ${drawOver ? '' : 'draw-module-btn--disabled'}`}>
                <Text className={`draw-module-btn-text ${drawOver ? '' : 'draw-module-btn-text--disabled'}`}>
                  {getDrawBtnText()}
                </Text>
              </LinearGradient>
            </Button>
            <Text className="draw-module-chance">{isPublicityStage || ((_f = drawInfo === null || drawInfo === void 0 ? void 0 : drawInfo.extra) === null || _f === void 0 ? void 0 : _f.drawChanceStatus) === DrawStatus.USED_UP ? "明天再来" : `还剩 ${canDrawCnt} 次抽奖机会`}</Text>
          </View>
        </View>
      </View>

      
      {renderPrizeModal()}

      
      {renderNoPrizeModal()}
    </View>
    </Sensor>;
};
export default memo(DrawModule);
